
<div *ngIf="customer">
    <gung-jeeves-jeeves-claim-list [customerId]="customer.id"></gung-jeeves-jeeves-claim-list>
</div>

